/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPGOAL = {
    CapitalGrowth: '1',
    Retirement: '2',
    Income: '3'
} as const;
export type IAPGOAL = typeof IAPGOAL[keyof typeof IAPGOAL];


export function IAPGOALFromJSON(json: any): IAPGOAL {
    return IAPGOALFromJSONTyped(json, false);
}

export function IAPGOALFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPGOAL {
    return json as IAPGOAL;
}

export function IAPGOALToJSON(value?: IAPGOAL | null): any {
    return value as any;
}

